export enum VerificationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}
